import ResetCursor from "./ResetCursor";

const LoadingActionWithIndex = (
  setLoadingIndex,
  index,
  callback,
  delay = 1500
) => {
  setLoadingIndex(index);

  setTimeout(() => {
    ResetCursor();

    if (callback) callback();

    setLoadingIndex(null);
  }, delay);
};

export default LoadingActionWithIndex;